module.exports = __webpack_public_path__ + "static/media/math.a9a2f1e2.png";